import { Button, Col, Row, Select, Space, Typography, Grid } from 'antd'
import Head from 'next/head'
import { useEffect, useState } from 'react'
import CustomBreadcrumb from 'src/components/CustomBreadcrumb'
import { PhoneOutlineIcon, TimeIcon } from 'src/components/CustomIcon'
import BASE_CONFIG from 'src/configs/base'
import addressServices from 'src/services/address.service'
import { usePostOffices } from 'src/services/postOffice.service'

const { Option } = Select
const { useBreakpoint } = Grid

const PostOfficeDetail = ({
	title,
	desc,
	phone,
	id,
	setHoverId,
	item,
	setCenter,
	hover,
	setChosenPostOffice,
	chosen,
}) => {
	return (
		<div
			className={`post-office-detail  ${chosen && 'chosen'}`}
		// onMouseEnter={() => {
		// 	setHoverId(id)
		// }}
		// onMouseLeave={() => {
		// 	setHoverId('')
		// }}
		>
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<div
				className="content"
				onClick={() => {
					setCenter([item.lat, item.lng])
					if (chosen) {
						setChosenPostOffice('')
						setHoverId('')
					} else {
						setChosenPostOffice(id)
						setHoverId(id)
					}
				}}
			>
				<img src="/images/postoffice.png" alt="post office" className="image" />
				<Row gutter={[8, 12]} style={{ width: '100%' }}>
					<Col xs={24} md={24} lg={24} xl={24}>
						<Typography.Text className="text title">{title}</Typography.Text>
					</Col>
					<Col xs={24} md={24} lg={24} xl={24}>
						<Typography.Text className="text desc">{desc}</Typography.Text>
					</Col>
					<Col xs={24} md={24} lg={24} xl={24} className="description">
						{phone && (
							<Space align="start">
								<PhoneOutlineIcon style={{ color: '#CC0000' }} />
								<Typography.Text className="text info">
									{["APU", "PCY", "TKE", "HUE", "DNI", "NTG", "PLG", "ETN", "PTH", "HHA", "CRG"].includes(id) ? "1900 6980" : phone}
									{/* {"1900 6980"} */}
								</Typography.Text>
							</Space>
						)}
						<Space align="start">
							<TimeIcon style={{ color: '#CC0000' }} />
							<Typography.Text className="text info">8:00 - 17:00</Typography.Text>
						</Space>
					</Col>
				</Row>
			</div>
			{chosen && (
				<Button className="button-contact">
					<a aria-label={"247Express-Nhanh hơn bạn nghĩ"} href={`tel:${phone}`}>Liên hệ</a>
				</Button>
			)}
		</div>
	)
}

const PostOffice = (props) => {
	const [data, setData] = useState([])
	const [dataFilter, setDataFilter] = useState([])

	const [hoverId, setHoverId] = useState('')
	const [center, setCenter] = useState([10.7615881, 106.6959822])
	const [cityID, setCityID] = useState('')
	const [districtID, setDistrictID] = useState(undefined)
	const [chosenPostOffice, setChosenPostOffice] = useState('')

	const { cities } = addressServices.usePMSCities()
	const { districts } = addressServices.usePMSDistricts(cityID)

	const { postOffices, isLoading, isError } = usePostOffices()

	const screens = Object.entries(useBreakpoint()).filter((item) => item[1]).length
	let urlMap = `https://maps.google.com/maps?q=${center[0]},%20${center[1]}&t=&z=14&ie=UTF8&iwloc=&output=embed`

	useEffect(() => {
		if (postOffices) {
			setDataFilter(postOffices)
			setData(postOffices)
		}
	}, [postOffices])

	useEffect(() => {
		if (districtID) {
			let newList = data.filter((item) => item.districtID === districtID)
			if (newList.length) {
				let centerList = Math.ceil((newList.length - 1) / 2)
				setCenter([newList[centerList].lat, newList[centerList].lng])
			}
			setDataFilter(newList)
		} else if (cityID) {
			let newList = data.filter((item) => item.provinceID === cityID)
			if (newList.length) {
				let centerList = Math.ceil((newList.length - 1) / 2)
				setCenter([newList[centerList].lat, newList[centerList].lng])
			}
			setDataFilter(newList)
		} else if (data.length) {
			setDataFilter(data)
		}
	}, [cityID, districtID])

	return (
		<div className="post-office-wrapper">
			<Head>
				<title>Tìm bưu cục | {BASE_CONFIG.SLOGAN}</title>
				<meta name="description" content="Tìm kiếm địa chỉ bưu cục 247Express nhanh chóng và chính xác tại các tỉnh thành trên toàn quốc. Hỗ trợ khách hàng tận tâm với hệ thống bưu cục rộng khắp."></meta>
			</Head>
			<CustomBreadcrumb />

			<div className="post-office-content">
				<div className="col map">
					<div className="mapouter">
						<div className="gmap_canvas">
							<iframe
								width={'100%'}
								height={screens < 4 ? (screens == 3 ? 650 : screens == 2 ? 550 : 450) : 800}
								id="gmap_canvas"
								src={urlMap}
								frameBorder={0}
								scrolling="no"
								marginHeight={0}
								marginWidth={0}
								title='gmap'
							/>
						</div>
					</div>{' '}
				</div>
				<div className="col search">
					<Row gutter={[10, 10]}>
						<Col span={24}>
							<Typography.Title level={5} className="title">
								Địa chỉ bưu cục
							</Typography.Title>
						</Col>
						<Col span={24} style={{ paddingRight: 24 }}>
							<Select
								onChange={(value) => {
									setCityID(value)
									setDistrictID(undefined)
								}}
								placeholder="Tỉnh/Thành phố"
								allowClear
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
								showSearch
								optionFilterProp="children"
								style={{ textTransform: 'capitalize', width: '100%' }}
							>
								{cities &&
									cities.map((item) => (
										<Option
											key={item?.provinceID}
											value={item?.provinceID}
											style={{ textTransform: 'capitalize' }}
										>
											{item?.provinceName?.toLowerCase()}
										</Option>
									))}
							</Select>
						</Col>
						<Col span={24} style={{ marginTop: 20, paddingLeft: 0, paddingRight: 0 }}>
							<Space direction="vertical" className="scroll-list">
								{dataFilter &&
									dataFilter.map((item) => {
										return (
											<PostOfficeDetail
												key={item.postOfficeID}
												title={`Bưu cục ${item.postOfficeName}`}
												desc={item.address}
												phone={item.phone}
												id={item.postOfficeID}
												setHoverId={setHoverId}
												item={item}
												setCenter={setCenter}
												hover={hoverId === item.postOfficeID}
												setChosenPostOffice={setChosenPostOffice}
												chosen={chosenPostOffice === item.postOfficeID}
											/>
										)
									})}
							</Space>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	)
}

export default PostOffice
